'use strict';

var MapActions = function (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('MapActions', APP_DISPATCHER_ID);

  // ANOTATIONS
  Actions.add({
    name: 'NewAnnotationStart',
    purpose: 'Indicates that a new annotation is being created',
    payload: []
  });

  Actions.add({
    name: 'EditAnnotationStart',
    purpose: 'Indicates that an existing annotation will be updated',
    payload: ['annotationId']
  });

  Actions.add({
    name: 'SaveActiveAnnotation',
    purpose: 'Indicates that active annotation edition is done should be saved',
    payload: []
  });

  Actions.add({
    name: 'AnnotationEditEnd',
    purpose: 'Dispatched when the annotation has been saved or canceled on edit',
    payload: ['saveChanges']
  });

  Actions.add({
    name: 'DestroyAnnotation',
    purpose: 'Signals that an annotation with the specified id will be destroyed',
    payload: ['annotationId']
  });

  Actions.add({
    name: 'NewMeasurementStart',
    purpose: 'Indicates that a new area for a measurement request should being drawn',
    payload: []
  });

  Actions.add({
    name: 'NewMeasurementRequest',
    purpose: 'Indicates that a measurement should be requested to the backend',
    payload: []
  });

  Actions.add({
    name: 'EditMeasurementStart',
    purpose: 'Indicates that a single measurement will be edited',
    payload: ['measurementId']
  });

  Actions.add({
    name: 'SaveActiveMeasurement',
    purpose: 'Indicates that active measurement edition is done should be saved',
    payload: []
  });

  Actions.add({
    name: 'MeasurementEditEnd',
    purpose: 'Dispatched when the area for a volume request is finished and the request should be dispatched',
    payload: ['saveChanges']
  });

  Actions.add({
    name: 'DestroyMeasurement',
    purpose: 'Indicates the measurement with the specified id should be destroyed',
    payload: ['measurementId']
  });

  Actions.add({
    name: 'ResizeMap',
    purpose: 'Informs leaflet that it should recalculate map size and pan as necessary',
    payload: []
  });

  Actions.add({
    name: 'SetLocation',
    purpose: 'Change the center latlng and zoom of the map',
    payload: ['location']
  });

  Actions.add({
    name: 'SetActiveLayer',
    purpose: 'Sends the active layer selected for editing',
    payload: ['layerId']
  });

  Actions.add({
    name: 'DeleteActiveAnnotationLayer',
    purpose: 'Removes the active annotation layer',
    payload: ['layerId']
  });

  Actions.add({
    name: 'EditOverlayStart',
    purpose: 'Indicates the active overlay will be edited',
    payload: ['overlayId']
  });

  Actions.add({
    name: 'EditOverlayEnd',
    purpose: 'Signals that the annotation will be saved or canceled',
    payload: ['saveChanges']
  });

  Actions.add({
    name: 'DestroyOverlay',
    purpose: 'Indicates the overlay with the specified id will be destroyed',
    payload: ['overlayId']
  });

  Actions.add({
    name: 'SaveActiveOverlay',
    purpose: 'Indicates that active overlay edition is done and should be saved',
    payload: []
  });

  Actions.add({
    name: 'ChangeAnnotationOverlayOpacity',
    purpose: 'Signals a change in the opacity of an overlay layer of an annotation',
    payload: ['annotationId', 'annotationLayerId', 'opacity']
  });

  Actions.add({
    name: 'ChangeOverlayOpacity',
    purpose: 'Signals a change in the opacity of an overlay added directly to the map',
    payload: ['overlayId', 'opacity']
  });

  Actions.add({
    name: 'ClearDownload',
    purpose: 'Alerts Pdf Preview Dialog to reset state and removes banner noticiation',
    payload: []
  });

  Actions.add({
    name: 'SetOpacityValues',
    purpose: 'Set the opacity values of the map and datacapture when the slider is changed',
    payload: ['opacities']
  });

  Actions.add({
    name: 'NewOverlay',
    purpose: 'Triggers the Overlord modal',
    payload: []
  });

  return Actions;
};

MapActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = MapActions;



// WEBPACK FOOTER //
// ./src/app/dash/map/MapActions.js